{
  "colorFormat": "Цветен формат",
  "hex": "шестнадесетичен",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
